import { SpokeDeliveryStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { Tooltip } from '@avantstay/backoffice-core'
import { IconAlert, IconClock } from '@avantstay/backoffice-vectors'

import * as S from './DeliveryStatus.styles'

interface DeliveryStatusProps {
  status?: SpokeDeliveryStatus | null
  error?: string | null
}

export const DeliveryStatus = ({ status, error }: DeliveryStatusProps) => {
  if (!status) return null

  if (status === SpokeDeliveryStatus.pending) {
    return (
      <S.Caption>
        <IconClock aria-hidden />
        Sending…
      </S.Caption>
    )
  }

  if (status === SpokeDeliveryStatus.failed) {
    return (
      <S.Caption $isFailed>
        <IconAlert aria-hidden />
        <Tooltip
          maxWidth={280}
          placement="top"
          content={error || 'The guest did not receive this message.'}
          trigger={['hover', 'focus']}
        >
          <S.FailedLabel tabIndex={0}>Not delivered</S.FailedLabel>
        </Tooltip>
      </S.Caption>
    )
  }

  return null
}
